import React, { useState, useEffect } from 'react';
import { useDailyActions } from '../../context/DailyActionsContext';
import { FaCheckCircle, FaRegCircle } from 'react-icons/fa';

const DailyActions = ({ compact = false }) => {
    const { dailyData, loading, toggleAction } = useDailyActions();

    const [shimmer, setShimmer] = useState(false);
    const [dailyConfetti, setDailyConfetti] = useState(false);

    const completedCount = dailyData?.actions?.filter((a) => a.completed).length || 0;
    const totalCount = dailyData?.actions?.length || 0;
    const progress = totalCount > 0 ? (completedCount / totalCount) * 100 : 0;

    useEffect(() => {
        if (progress === 100) {
            setShimmer(true);
            setDailyConfetti(true);
            const timer = setTimeout(() => {
                setShimmer(false);
                setDailyConfetti(false);
            }, 1500);
            return () => clearTimeout(timer);
        }
    }, [progress]);

    if (loading) return <div>Chargement...</div>;

    const actionLabels = {
        prayer: 'Prière (الصلاة)',
        tasbih: 'Tasbih (التسبيح)',
        recitation: 'Coran (تلاوة)',
        douaa: 'Douaa (الدعاء)',
        sadaqa: 'Sadaqa (الصدقة)',
    };

    return (
        <div className={`daily-actions-container ${compact ? 'compact' : ''}`}>
            {compact ? <h3>Dîne au quotidien</h3> : <h2>Dîne au quotidien</h2>}

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '15px' }}>
                <div className="progress-bar-container" style={{ flex: 1, marginBottom: 0 }}>
                    <div className={`progress-bar ${shimmer ? 'shimmer-effect' : ''}`} style={{ width: `${progress}%` }}></div>
                </div>
                <div className={`daily-progress-wrapper ${dailyConfetti ? 'confetti-active' : ''}`}>
                    <span style={{ fontWeight: 'bold', fontSize: '0.9rem', color: compact ? 'var(--text-light)' : 'var(--primary-color)', minWidth: '35px' }}>
                        {Math.round(progress)}%
                    </span>
                </div>
            </div>
            <ul className="action-list">
                {dailyData?.actions?.map((action) => (
                    <li
                        key={action.name}
                        className={`action-item ${action.completed ? 'completed' : ''}`}
                        onClick={() => toggleAction(action.name)}
                    >
                        {action.completed ? <FaCheckCircle /> : <FaRegCircle />}
                        <span>{actionLabels[action.name] || action.name}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default DailyActions;
